import { useNavigate } from 'react-router-dom';
import images from '../../assets/images';
import './LibraryHeader.scss';
import CommonSearch from '../Search/CommonSearch';
import { useAppSelector } from '../../redux/app/hooks';
import { SCHOOL_ADMIN, STUDENT_ROLE } from '../../utils/constants';
import { getScreenDimensions } from '../../utils/helper';
import MobileHeader from '../MobileHeader/MobileHeader';
import { useCallback, useRef, useState } from 'react';
import { Tooltip } from '@mui/material';

interface propsType {
    image: any;
    subject: string;
    subCategory: string;
    setIsUploadOpen?: any;
    setOpen?: any;
    openPdf?: boolean;
    onClose?: any;
    backNavigation? : {
        path:string;
        state: any;
    };
    handleSearchDebounce?: any;
    searchValue?: string;
    setSearchValue?: any;
    demoFile?:boolean;
    backgroundColor: string;
    openVideo?: any;
    videoRef?: any;
}
const LibraryHeader = ({ image, subject, subCategory, setIsUploadOpen, openPdf, onClose, setOpen, backNavigation, handleSearchDebounce, searchValue, setSearchValue,demoFile, backgroundColor, openVideo, videoRef}: propsType) => {
    const { backArrow, uploadCloud, CloudDownload, searchCloseIcon, bookIcon, plusIcon } = images;
    const navigate = useNavigate();
    const baseURL = process.env.REACT_APP_FRONTEND_URL;
    const role = useAppSelector((state) => state.auth.role);
    const [isSearchClick, setisSearchClick] = useState<boolean>(false);
    const classroomName = useAppSelector((state) => state.CommonUpload.classroomName)
    

    //To open upload popup
    const handleOpenUpload = () => {
        setIsUploadOpen(true);
        setOpen(true);
    };

    const handleSearchClick = () => {
        setisSearchClick(true);
    }
    const handleCloseSearch = () => {
        setSearchValue("");
        handleSearchDebounce("");
        setisSearchClick(false);
    }

    const textRef = useRef<HTMLDivElement>(null);
  const [isEllipsisActive, setIsEllipsisActive] = useState(false);

  // Function to check if text is truncated (ellipsis applied)
  const checkEllipsis = useCallback(() => {
    if (textRef.current) {
      setIsEllipsisActive(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, []);

    return (
        <div className={subCategory?.includes("Questions Bank /") ? "libraryHeaderQsBank":`libraryHeader ${role === SCHOOL_ADMIN ? 'libraryHeaderAdmin': ""}`}>
            {((!isSearchClick) || (openPdf)) && <div className='libraryHeaderBack'>
                {openPdf ?
                <img
                onClick={() => {
                    let prevVideoRef;
                    if(videoRef) {
                        prevVideoRef = {
                            currentTime: videoRef.current.currentTime,
                        };
                    };
                    onClose(prevVideoRef)
                }}
                className="backArrow"
                alt="back-arrow"
                src={backArrow}
                />:
                <img
                    onClick={() => {
                        navigate(backNavigation?.path ? backNavigation?.path : "",
                            {
                                state: backNavigation?.state
                            });
                    }}
                    className="backArrow"
                    alt="back-arrow"
                    src={backArrow}
                />}
                {role !== SCHOOL_ADMIN && image !== '' && subject !== '' && subCategory !== '' && backgroundColor !== '' && <div className='libraryHeaderRoutes'>
                        <div className='headerImageContainer' style={{backgroundColor: image ? "none" : backgroundColor}}>
                            {(image) ? 
                                <img src={ image } alt='headerImage' className='headerImage' /> 
                            :   <span className='subjectHeader' style={{backgroundColor: backgroundColor}}>{ subject?.charAt(0).toUpperCase() }</span>   }
                        </div>
                        <Tooltip
      title={isEllipsisActive ? `${subject} / ${subCategory}` : ""}
    >
      <div
        ref={textRef}
        className="headerRouterName"
        onMouseEnter={checkEllipsis} // Check ellipsis on hover
      >
        <span className="headerName">
          {subject} / {subCategory}
        </span>
      </div>
    </Tooltip>                </div>
                }
                 {role === SCHOOL_ADMIN &&  <div className="header-div">
                <div className="imageContainer">
                  <img src={bookIcon} alt="userImage" className="imageStyle" />
                </div>
                <div className="header-title-div">
                  <div className="primary">Upload</div>
                  <div className="secondary">
                    {`${classroomName} - ${subCategory} - ${subject}` }
                  </div>
                </div>
              </div>}
            </div>}
            {
                openPdf ?
                    <div className='libraryHeaderClose' onClick={onClose}>
                        {/* <img src={closeIcon} alt="close" className='closeImage' /> */}
                    </div>
                    :
                    
                    // (getScreenDimensions()?.isMobileScreen ? 
                    //     <></>
                    //     // <MobileHeader handleSearchClick={handleSearchDebounce}/>
                    // :
                    <div className='libraryHeaderSearchAndUpload'>
                    {((getScreenDimensions()?.isMobileScreen && isSearchClick) || (!getScreenDimensions()?.isMobileScreen && handleSearchDebounce)) && <CommonSearch
                            handleSearchDebounce={handleSearchDebounce}
                            searchValue={searchValue}
                            setSearchValue={setSearchValue}
                            from={`LibraryHeader`}
                    />}
                    {(getScreenDimensions()?.isMobileScreen && isSearchClick) && <img src={searchCloseIcon} alt='closeIcon' className='closeIcon' onClick={handleCloseSearch} />}
                    {(role !== STUDENT_ROLE && demoFile && !getScreenDimensions().isMobileScreen)&& <div className='sampleContainer'>
                        <a  href={baseURL+'materials/QuestionsBankSample.csv'} download rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} className='link'>
                            <img src={CloudDownload} alt="upload" className='downloadImage' />
                            <label className='demoFilename'>{`Sample csv`}</label>
                        </a>
                    </div>}

                     {role === SCHOOL_ADMIN && <div className='tabHeaderRightContainer' onClick={handleOpenUpload}> <div className='bulk'>Upload</div>
         <div className='plusIconContainer'>
          <img src={plusIcon} alt="plusIcon" className='plusIconStyle' />
        </div> 
        </div>}
                    {((role !== STUDENT_ROLE && role !==SCHOOL_ADMIN) && !getScreenDimensions()?.isMobileScreen) && <div className='libraryHeaderUpload' onClick={handleOpenUpload}>
                        <img src={uploadCloud} alt="upload" className='uploadImage' />
                    </div>}
                    </div>
                    // )
                    
            }

            {!isSearchClick && !openPdf && getScreenDimensions()?.isMobileScreen && <MobileHeader handleSearchClick={handleSearchClick} />}
        </div>
    )
}

export default LibraryHeader;
